<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="openingbalances_pg.icon" class="mr-1"></i>
            <span>{{ openingbalances_pg.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="NL A/C" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="nlcode" :debounce="openingbalances_pg.debounce"
                      placeholder="NL A/C"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!nlcode" @click="nlcode = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="openingbalances_pg.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description"
                        @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Period" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="period" :debounce="openingbalances_pg.debounce"
                      placeholder="Period"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!period" @click="period = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="openingbalances_pg" :icon="openingbalances_pg.icon"
            :busy="openingbalances_pg.busy" :toolbarlibrary="openingbalances_pg.toolbarlibrary" :tools="openingbalances_pg.tools"
            :badges="openingbalances_pg.badges" :fields="openingbalances_pg.fields" :items="openingbalances_pg.items"
            :limit="openingbalances_pg.limit" :page="openingbalances_pg.page" @load="openingbalances_pg_load"
            @click="openingbalances_pg_click" @changed="openingbalances_pg_click('save', $event)"
            @select="openingbalances_pg_select">
          </d-table>
        </div>
      </div>
      <div v-if="component">
        <component :is="component" :selection="openingbalances_pg.selected" :config="cconfig"
          @discard="openingbalances_pg_click('discard')" @go="openingbalances_pg_click('go')"></component>
      </div>
      <!-- <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer> -->

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import OpeningBalancePGEdit from "./Components/OpeningBalancePGEdit";

export default {
  name: "OpeningBalancesPG",
  components: { OpeningBalancePGEdit },
  watch: {
    async nlcode() {
      await this.openingbalances_pg_load(0);
    },
    async description() {
      await this.openingbalances_pg_load(0);
    },
    async period() {
      await this.openingbalances_pg_load(0);
    },
  },
  data() {
    return {
      period: null,
      description: null,
      nlcode: null,
      //   code_options: [],

      openingbalances_pg: {
        title: "Opening Balances",
        icon: "fa fa-play",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,export,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "nlcode",
            label: "NL A/C",
            sortable: true,
          },
          {
            key: "description",
            label: "Description",
            sortable: true,
          },
          {
            key: "period",
            label: "Period",
            sortable: true,
          },
          {
            key: "amount",
            label: "Amount",
            type: "text",
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            // totalled: true,
            // total: 0,
          },

          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        denied: [],
      },
    };
  },
  async mounted() {
    await this.openingbalances_pg_load();
  },

  methods: {
    async openingbalances_pg_load(offset, limit, page) {
      let state = this.openingbalances_pg;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        // id: this.id,
        nlcode: this.nlcode,
        period: this.period,
        description: this.description,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_openingbalances_pg(
              $limit: Int
              $offset: Int
              $nlcode: String
              $period: String
              $description: String
            
            ) {
              setup_openingbalances_pg(
                limit: $limit
                offset: $offset
                nlcode: $nlcode
                period: $period
                description: $description
               
              ) {
                id
                nlcode
                period
                description
                amount
                rows
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.setup_openingbalances_pg
        } else {
          state.items = []
          state.items = response.data.setup_openingbalances_pg;
        }


      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async openingbalances_pg_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.openingbalances_pg_load();
          break;
        case "add":
        case "edit":
          this.component = "OpeningBalancePGEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async openingbalances_pg_select(ss, tools) {

      let state = this.openingbalances_pg;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_openingbalances_pg_save(
                $rows: [setup_openingbalances_pg_input]             
              ) {
                setup_openingbalances_pg_save(rows: $rows) {
                    id
                    nlcode
                    description
                    period
                    amount                    
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_openingbalances_pg_delete(
                $rows: [setup_openingbalances_pg_input]
              ) {
                setup_openingbalances_pg_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.openingbalances_pg_load(0);
    },
  },
};
</script>

<style></style>